<template>
  <section class="companyGames" id="companyGames">
    <div class="container">
      <h2 class="block-title">
        {{ portalData.CompanyGames.biggest_projects[lang] }}
      </h2>
      <div class="companyGames__wrapper">
        <div
            v-for="game in games"
            :key="game.id"
            class="companyGames__item"
            @click="openGame(game.id, $event)"
        >
          <span class="img desktop" :style="{ backgroundImage: `url(${game.bgDesktop})` }"></span>
          <span class="img mobile" :style="{ backgroundImage: `url(${game.bgMobile})` }"></span>
          <span class="companyGames__item-blur"></span>
          <div class="companyGames__item-wrapper">
            <div class="companyGames__item-logo">
              <img :src="game.logo" :alt="game.title" />
            </div>
            <div class="companyGames__item-content">
              <p class="companyGames__item-title">{{ game.title }}</p>
              <p class="companyGames__item-text">{{ game.text }}</p>
              <div class="companyGames__item-links">
                <a v-for="link in game.links" :key="link.img" :href="link.url" target="_blank">
                  <img :src="link.img" alt="" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="companyGames__button">
        <a class="button" href="/games/all" target="_blank">
          {{ portalData.CompanyGames.show_all[lang] }}
        </a>
      </div>
    </div>
  </section>
</template>

<script>
import portalData from './../../portal.json';
export default {
  name: 'CompanyGames',
  data() {
    return {
      gamesList: ['mergecraft', 'wondermerge', 'fairy', 'riddles'],
      portalData
    };
  },
  computed: {
    lang() {
      return this.language;
    },
    games() {
      return this.gamesList.map((gameId) => {
        const data = this.portalData.games[gameId];
        const platforms = ['ios', 'android', 'xsolla'];
        return {
          id: gameId,
          bgDesktop: require(`./../../assets/${data.background_desktop[this.lang]}`),
          bgMobile: require(`./../../assets/${data.background_mobile[this.lang]}`),
          logo: require(`./../../assets/${data.logo[this.lang]}`),
          title: data.title_short[this.lang],
          text: data.bonus[this.lang],
          links: platforms.map((platform) => ({
            url: data.links[platform],
            img: require(`./../../assets/platforms/${platform}.png`)
          }))
        };
      });
    }
  },
  methods: {
    openGame(gameId, event) {
      event.preventDefault();
      const linkData = this.$router.resolve({ name: 'Play Now', params: {game: gameId} });
      window.open(linkData.href, '_blank');
    }
  }
};
</script>

<style scoped>
.companyGames {
  padding: 80px 0 30px;
}

.companyGames__wrapper {
  margin-top: 50px;
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
}

.companyGames__item {
  width: calc(25% - 10.5px);
  border-radius: 30px;
  overflow: hidden;
  position: relative;
  color: #fff;
  font-size: 24px;
  aspect-ratio: 9 / 13.6;
  cursor: pointer;
  transition: box-shadow 0.3s;
}
.companyGames__item:hover,
.companyGames__item:active {
  box-shadow: 0 4px 24px 0 rgba(16, 80, 175, 0.2);
}

.companyGames__item .img {
  position: absolute;
  left: 0; top: 0;
  width: 100%; height: 100%;
  background-size: cover;
  background-position: center;
  z-index: 2;
  transition: 0.5s;
}
.companyGames__item .img.desktop { display: block; }
.companyGames__item .img.mobile { display: none; }

.companyGames__item-wrapper {
  position: relative;
  z-index: 5;
  padding: 30px 32px;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.companyGames__item-logo {
  width: 100%;
  margin-bottom: auto;
  height: 150px;
}
.companyGames__item-logo img {
  max-width: 100%;
  max-height: 100%;
  margin: auto;
}

.companyGames__item-content {
  margin-top: 50px;
}

.companyGames__item-title,
.companyGames__item-text,
.companyGames__item-links {
  opacity: 0;
  transition: 0.5s;
}
.companyGames__item-title {
  margin-top: auto;
  font-family: 'Marvin', sans-serif;
  font-size: 22px;
  font-weight: 700;
}
.companyGames__item-text {
  margin-top: 20px;
  max-width: 360px;
  width: 100%;
  font-weight: bold;
  font-size: 16px;
}
.companyGames__item-links {
  display: flex;
  gap: 26px;
  margin-top: 54px;
  transition: 0.3s;
}
.companyGames__item-blur {
  pointer-events: none;
  position: absolute;
  z-index: 3;
  left: 0; top: 0; width: 100%; height: 100%;
  opacity: 0;
  transition: opacity 0.35s;
  background: rgba(0,0,0,0.32);
  backdrop-filter: blur(6px);
  border-radius: inherit;
}
.companyGames__item:hover .companyGames__item-blur,
.companyGames__item:active .companyGames__item-blur {
  opacity: 1;
}
.companyGames__item-links a {
  max-width: 34px;
  width: 100%;
  display: flex;
  opacity: 0.55;
  transition: 0.3s;
}
.companyGames__item-links img {
  width: 100%;
  margin: auto;
}
.companyGames__item-links a:hover,
.companyGames__item-links a:active {
  opacity: 1;
}

.companyGames__item:hover .companyGames__item-title,
.companyGames__item:active .companyGames__item-title,
.companyGames__item:hover .companyGames__item-text,
.companyGames__item:active .companyGames__item-text,
.companyGames__item:hover .companyGames__item-links,
.companyGames__item:active .companyGames__item-links {
  opacity: 1;
}

.companyGames__item:before,
.companyGames__item:after {
  content: '';
  left: 0; width: 100%;
  position: absolute;
}
.companyGames__item:before {
  top: 0; height: 100%;
  z-index: 3;
  opacity: 0;
  background: rgba(0,0,0,.2);
  transition: 0.5s;
}
.companyGames__item:hover:before,
.companyGames__item:active:before {
  opacity: 1;
}
.companyGames__item:after {
  bottom: 0; height: 70%;
  z-index: 3;
  background: linear-gradient(to bottom, transparent, rgba(0,0,0,.6));
  opacity: 0;
  transition: 0.3s;
}
.companyGames__item:hover:after,
.companyGames__item:active:after {
  opacity: 1;
}

.companyGames__button {
  margin-top: 40px;
  display: flex;
  justify-content: center;
}
.button {
  padding: 14px 40px;
  background: #16a6ff;
  text-decoration: none;
  color: #fff;
  font-weight: bolder;
  border-radius: 30px;
  font-size: 18px;
  font-family: 'Marvin', sans-serif;
  text-align: center;
  transition: 0.3s;
  display: inline-block;
}

@media (max-width: 1450px) {
  .companyGames__item-text { font-size: 12px; }
  .companyGames__item-content { margin-top: 10px; }
  .companyGames__item-logo { height: 95px; text-align: center; }
  .companyGames__item-title { font-size: 16px; margin-top: 12px; }
}
@media (max-width: 1000px) {
  .companyGames__wrapper { gap: 8px; }
  .companyGames__item { font-size: 18px; width: calc(50% - 10px); }
  .companyGames__item-content { margin-top: 15px; display: flex; align-items: end; flex-direction: column; flex: 1; }
  .companyGames__item-links { width: 100%; margin-top: 27px; }
  .companyGames__item-text { margin-top: 12px; font-size: 12px; }
  .companyGames__item-logo { height: 110px; }
  .companyGames__item-title { width: 100%; font-size: 16px; margin-bottom: 0; }
}
@media (max-width: 650px) {
  .companyGames__wrapper { gap: 14px; flex-direction: column; }
  .companyGames__item { font-size: 15px; border-radius: 15px; width: 100%; max-height: 170px; }
  .companyGames__item-wrapper { padding: 18px 16px; flex-direction: row-reverse; }
  .companyGames__item-logo { height: 60px; max-width: 150px; }
  .companyGames__item-content { margin-top: 4px; flex: 1; }
  .companyGames__item-links { margin-top: 8px; gap: 10px; }
  .companyGames__item-title { font-size: 16px; }
  .companyGames__item-text { margin-top: 6px; font-size: 12px; }
  .companyGames__item .img.desktop { display: none; }
  .companyGames__item .img.mobile { display: block; }
}
</style>